'use strict';

var useDebounce$1 = require('../../../../../../../../_virtual/useDebounce.cjs');
var React = require('react');

var react = React;

/**
 * Custom debounce function
 */ const debounce = (fn, delay = 0)=>{
    let timeout;
    const debounced = (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn(...args);
        }, delay);
    };
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
};
/**
 * Debounce hook
 */ const useDebounce = (fn, delay)=>{
    const ref = react.useRef(debounce(fn, delay));
    return ref.current;
};

useDebounce$1.__exports.useDebounce = useDebounce;

module.exports = useDebounce$1.__exports;
//# sourceMappingURL=useDebounce.cjs.map
